












import Vue from "vue";
import Component from "vue-class-component";
import { LGeoJson } from "vue2-leaflet";
import { Layer } from "leaflet";
import { features } from "@/store";
import { IChartAchare } from "@/store/features/models";

@Component({
  components: {
    LGeoJson,
  },
})
export default class ChartAnchorageLayer extends Vue {
  //computed
  get chartAchare() {
    return features.getters.chartAchare;
  }
  get geoJsonOptions() {
    return {
      onEachFeature: this.onEachFeatureFunction,
    };
  }
  get styleFunction() {
    return () => {
      return {
        fillColor: "blue",
        weight: 1,
        color: "black",
        opacity: 0.5,
        fillOpacity: 0.5,
      };
    };
  }
  get onEachFeatureFunction() {
    return (feature: IChartAchare, layer: Layer) => {
      let info = feature.properties.national_info || "No disponible";
      layer.bindTooltip(info, {
        permanent: false,
        sticky: true,
      });
    };
  }

  loadFeatures() {
    if (!this.chartAchare.length) {
      features.dispatch("getChartAchare");
    }
  }

  created() {
    this.loadFeatures();
  }
}
